/**
 * Build-time switch for the unlinked `/auth/reviewer` password sign-in. Set
 * `VITE_REVIEWER_SIGNIN_ENABLED=true` only for environments and windows where a
 * directory reviewer needs it; anything else leaves the route a 404.
 */
export const isReviewerSignInEnabled = (): boolean =>
  import.meta.env.VITE_REVIEWER_SIGNIN_ENABLED === 'true';
